module.exports = __webpack_public_path__ + "assets/pdf/handbook-cn.d80914cf.epub";